import { SET_CURRENT_SITE } from '../action-types'

export default (state = null, action) => {
  switch (action.type) {
    case SET_CURRENT_SITE:
      return action.payload

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/modules/sites/reducers/currentSite.js